import { TranslateService } from '@ngx-translate/core';

import { Recurrence } from '../models/schedule';

/**
 * Human-readable repeat hint for a schedule's recurrence ("Daily",
 * "Every [n] weeks", …). Shared by `ScheduleDisplay` and the setup wizard's
 * room-tile tooltips so the wording (and its i18n keys) cannot drift apart.
 */
export function recurrenceLabel(rec: Recurrence, translate: TranslateService): string {
  const n = rec.interval;
  switch (rec.frequency) {
    case 'daily':
      return n === 1 ? translate.instant('Daily') : translate.instant('Every [n] days', { n });
    case 'weekly':
      return n === 1 ? translate.instant('Weekly') : translate.instant('Every [n] weeks', { n });
    case 'monthly':
      return n === 1 ? translate.instant('Monthly') : translate.instant('Every [n] months', { n });
    default:
      return '';
  }
}
